import { Grid2, Stack, useTheme } from "@mui/material";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { EmphasizedButton } from "./EmphasizedButton";
import { SecondaryButton } from "./SecondaryButton";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";

type Props = {
    ssqId: number;
    scoreId: string;
    isComplete: boolean;
};
export const DiagnosticActions = (props: Props) => {
    const theme = useTheme();
    const { isFeatureActivated } = useApplicationParameters();
    const { currentCampaign } = useFoodpilotContext();
    const { company } = useCompanyMetadata();

    if (currentCampaign === null) {
        return null;
    }

    const campaignId = currentCampaign.id;
    const { isComplete, ssqId, scoreId } = props;
    const metaForUrl = {
        companyId: company.id,
        ssqId,
        campaignId,
        scoreId,
    };

    const areScoreDetailsActivated =
        isFeatureActivated("FS-company-score-details-distribution") ||
        isFeatureActivated("FS-company-score-details-comparison");

    return (
        <Stack>
            <Grid2 container columns={12} spacing={theme.spacing(2)}>
                <Grid2 size={{ md: 6, sm: 12 }}>
                    <EmphasizedButton metaForUrl={metaForUrl} isComplete={isComplete} />
                </Grid2>
                {areScoreDetailsActivated && (
                    <Grid2 size={{ md: 6, sm: 12 }}>
                        <SecondaryButton metaForUrl={metaForUrl} isComplete={isComplete} />
                    </Grid2>
                )}
            </Grid2>
        </Stack>
    );
};
